import { useRouter } from "../lib/router";

const TABS = [
  { path: "/", label: "Film", icon: "ph-film-strip", match: (p: string) => p === "/" || p.startsWith("/order") },
  { path: "/orders", label: "Orders", icon: "ph-tray-arrow-down", match: (p: string) => p.startsWith("/orders") },
  { path: "/pickups", label: "Pickups", icon: "ph-calendar-check", match: (p: string) => p.startsWith("/pickups") },
  { path: "/drop", label: "Drop", icon: "ph-storefront", match: (p: string) => p.startsWith("/drop") },
  { path: "/mailin", label: "Mail", icon: "ph-mailbox", match: (p: string) => p.startsWith("/mailin") },
  { path: "/account", label: "Account", icon: "ph-user", match: (p: string) => p.startsWith("/account") },
];

export function BottomNav() {
  const { path, navigate } = useRouter();
  return (
    <nav className="fixed bottom-0 inset-x-0 bg-surface/95 backdrop-blur border-t border-line z-20 pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-md mx-auto grid grid-cols-6">
        {TABS.map((t) => {
          const active = t.match(path);
          return (
            <button
              key={t.path}
              onClick={() => navigate(t.path)}
              className={`flex flex-col items-center justify-center gap-0.5 h-16 ${active ? "text-navy" : "text-ink-subtle"}`}
            >
              <i className={`ph${active ? "-fill" : ""} ${t.icon} text-[21px]`} />
              <span className="text-[10px] font-medium">{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
